import { AlertCircle, ArrowLeft } from "react-feather"
import { useNavigate } from "react-router-dom"
import { Button } from "@/components/ui/button"

interface ErrorPageProps {
  title: string
  message: string
  backPath?: string
}

export function ErrorPage({ title, message, backPath }: ErrorPageProps) {
  const navigate = useNavigate()

  const handleBack = () => {
    if (backPath) {
      navigate(backPath)
    } else {
      navigate(-1)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-lg shadow-sm p-8 text-center">
          <div className="flex justify-center mb-4">
            <div className="w-16 h-16 bg-red-50 rounded-full flex items-center justify-center">
              <AlertCircle className="w-8 h-8 text-red-500" />
            </div>
          </div>
          <h1 className="text-xl font-bold text-slate-900 mb-2">{title}</h1>
          <p className="text-sm text-slate-600 mb-6">{message}</p>
          <Button onClick={handleBack} variant="outline" className="w-full">
            <ArrowLeft size={16} className="mr-2" />
            戻る
          </Button>
        </div>
      </div>
    </div>
  )
}
